import * as React from 'react';
import { snap, story, visualize } from 'storybook-snapper';
import { Input } from '..';

visualize('Input', () => {
  story('simple', () => {
    snap('default props', <Input />);

    snap('with value', <Input value="Some text" />);

    snap('disabled', <Input disabled />);

    snap('disabled with value', <Input value="Some text" disabled />);

    snap('error', <Input error errorMessage="Some error message" />);

    snap(
      'error with value',
      <Input value="Some text" error errorMessage="Some error message" />,
    );
  });
});
